import { Search } from 'lucide-react';
import * as React from 'react';
import { cn } from '../lib/cn';

// The prototype's search bar: full width, rounded, with a search icon. `aside` sits inside the bar on the right (e.g.
// the "Filters" toggle on send money history).
export function SearchBar({ value, onChange, label, placeholder, aside, className }: {
  value: string; onChange: (v: string) => void; label: string; placeholder: string; aside?: React.ReactNode; className?: string;
}) {
  return (
    <div className={cn('relative flex h-11 items-center rounded-full border border-line bg-surface focus-within:border-tick focus-within:ring-2 focus-within:ring-tick/25', className)}>
      <Search className="pointer-events-none absolute left-4 size-4 text-ink-3" aria-hidden />
      <input type="search" aria-label={label} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)}
        className="h-full min-w-0 flex-1 rounded-full bg-transparent pl-10 pr-4 text-[15px] text-ink placeholder:text-ink-3 focus:outline-none" />
      {aside && <div className="flex shrink-0 items-center pr-4">{aside}</div>}
    </div>
  );
}
